import { get, patch } from './client';
import { ROUTES } from './config';
import type { Notification } from '@/types/types';

export interface NotificationsListResponse {
    status: number;
    data: Notification[];
}

export const notificationsApi = {
    list: () => get<NotificationsListResponse>(ROUTES.NOTIFICATIONS),
    markAsRead: (id: string) =>
        patch<void>(`${ROUTES.NOTIFICATIONS}/markAsRead/${id}`),
};
